import { defineStore } from 'pinia';

export interface ChatPage {
  path: string;
  title: string;
}

/**
 * The open state of the chat panel. It is a store and not the state of a page, so the panel and
 * its conversation stay across page changes.
 */
export const useChatPanelStore = defineStore('chatPanel', {
  state: () => ({
    open: false,
    /** An answer arrived while the panel was closed. The header button shows a dot. */
    unread: false,
    /** The current page, for the context chip. */
    page: null as ChatPage | null,
  }),

  actions: {
    show() {
      this.open = true;
      this.unread = false;
    },

    hide() {
      this.open = false;
    },

    toggle() {
      if (this.open) this.hide();
      else this.show();
    },

    answerArrived() {
      if (!this.open) this.unread = true;
    },

    pageChanged(page: ChatPage) {
      this.page = page;
    },
  },
});
